import { getStatus } from "@/physio-demo/hours";

const LINKS = [
    { label: "Manifesto", href: "#manifesto", id: "nav-link-manifesto" },
    { label: "Services", href: "#services", id: "nav-link-services" },
    { label: "Hours & Location", href: "#hours", id: "nav-link-hours" },
    { label: "Insurance", href: "#insurance", id: "nav-link-insurance" },
    { label: "Book", href: "#book", id: "nav-link-book" },
];

export const Nav = () => {
    const status = getStatus();
    return (
        <header
            data-testid="site-header"
            className="fixed top-10 left-0 right-0 z-50 border-b border-line bg-bone/80 backdrop-blur-xl"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
                <a href="#top" data-testid="nav-brand-logo" className="group flex items-center gap-3">
                    <span className="block h-3 w-3 bg-ochre transition-transform duration-300 group-hover:rotate-45" />
                    <span className="font-syne text-sm font-bold uppercase tracking-[0.18em]">
                        Physio on Elm
                    </span>
                </a>
                <nav className="hidden items-center gap-7 md:flex" data-testid="nav-links">
                    {LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={l.href}
                            data-testid={l.id}
                            className="font-mono text-[11px] uppercase tracking-[0.2em] text-mutedink transition-colors duration-300 hover:text-ink"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div
                    data-testid="nav-status-badge"
                    className="flex items-center gap-2 border border-line bg-badge px-3 py-1.5"
                >
                    <span
                        className={`h-1.5 w-1.5 rounded-full animate-pulse-dot ${status.open ? "bg-green-700" : "bg-ochre"}`}
                    />
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-ink">
                        {status.label}
                    </span>
                </div>
            </div>
        </header>
    );
};
